import React, { useContext } from 'react';

import { MDText } from 'i18n-react';

import { PayCardIcon } from '@motorway/mw-highway-code';

import { VehicleLookupContext } from 'Context/vehicleLookup';

import { FLAG } from 'Utilities/analytics/optimizely/constants';

import { useBinaryExperiment } from 'Containers/app/experiments/useBinaryExperiment';

import { HeroInput } from '../../../../../common/Hero/HeroInput/HeroInput';
import { HeroVehicle } from '../../../../../common/Hero/HeroVehicle/HeroVehicle';
import { useHeroRouteChangeHelpers } from '../../../../../common/Hero/Hooks/useHeroRouteChangeHelpers';
import Lock from '../../../../../fastlane/lock/Lock';
import LocalTexts from '../../../../HomepageTexts.json';
import { HeroProps } from '../../Hero';
import { HeroContent } from '../HeroContent/HeroContent';

import { TrustPilotHero } from './TrustPilotHero';

import styles from './HomepageVRM.scss';

const LocalT = new MDText(LocalTexts);

type HomepageVRMProps = {
  inProgress?: boolean;
  loadingHandler?: (value: any) => void;
} & HeroProps;

export const HomepageVRM = ({
  inProgress = false,
  loadingHandler,
}: HomepageVRMProps) => {
  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);
  const inFinanceMessageExperiment = useBinaryExperiment(FLAG.MW_5_2_HOME_FINANCE_MESSAGE, { triggerExperiment: true });

  const {
    onNotMyCarClick: onNotMyCarClickHandler,
    setMileageUrl,
    showMileage,
  } = useHeroRouteChangeHelpers({ vehicle });

  return (
    <Lock lock={inProgress}>
      <div className={styles.component}>
        {(showMileage)
          ? (<HeroVehicle
            {...{ onNotMyCarClickHandler, vehicle }}
          />)
          : (<HeroContent />)}
        <HeroInput
          className={styles.heroInput}
          setShowMileage={setMileageUrl}
          {...{
            inProgress,
            loadingHandler,
            showMileage,
            vehicle,
          }}
        />
        {inFinanceMessageExperiment && (
          <div className={styles.financeMessageWrapper}>
            <span className={styles.iconWrapper}>
              <PayCardIcon size="xsmall" />
            </span>
            <p data-thc-style-override className={styles.financeMessage}>
              {LocalT.translate('outstandingFinance', { boldText: <span>{LocalT.translate('outstandingFinanceBold')}</span> })}
            </p>
          </div>)}
        <TrustPilotHero />
      </div>
    </Lock>
  );
};
